import React, { createRef, RefObject } from 'react'
import { VideoSourceInfo } from '../hooks/useHlsManager'

type HLSContext = {
    setVideoElementRef:
        | null
        | ((
              playlistIndex: number,
              videoIndex: number,
              videoRef: RefObject<HTMLVideoElement>,
          ) => void)
    resetVideoLoc: null | ((playlistIndex: number, videoIndex: number) => void)
    hlsInstances: RefObject<VideoSourceInfo[][]>
    detachAll: null | (() => void)
}
const DefaultHLSContext: HLSContext = {
    setVideoElementRef: null,
    resetVideoLoc: null,
    hlsInstances: createRef<VideoSourceInfo[][]>(),
    detachAll: null,
}

export const HLSContext = React.createContext(DefaultHLSContext)
